export default __webpack_public_path__ + "static/media/cotton.9e9cfcff.png";